import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loading from '../Loading';
import Error from '../Error';
import Auth0Notification from '../Auth0Notification';
import QuotaSummaryUsersConsumption from '../QuotaSummaryUsersConsumption';
import QuotaSummaryFeatureConsumption from '../QuotaSummaryFeatureConsumption';
import ApplianceStatusNotification from '../ApplianceStatusNotification';
import noop from '../../utils/noop';

import { REPORT_REFRESH_24HRS } from '../../utils/resources/reports';

import './styles.css';

class QuotaSummary extends Component {
  constructor(props) {
    super(props);
    this.state = { showApplianceStatusModal: false };
    this.showApplianceStatusModal = this.showApplianceStatusModal.bind(this);
    this.hideApplianceStatusModal = this.hideApplianceStatusModal.bind(this);
  }

  showApplianceStatusModal() {
    this.setState({ showApplianceStatusModal: true });
  }

  hideApplianceStatusModal() {
    this.setState({ showApplianceStatusModal: false });
  }

  render() {
    const {
      loading,
      error,
      reportData,
      contactSales,
      contactSalesLink,
      showReportDetails,
      shouldRenderSummary,
      isAppliance,
      applianceUsageRecords,
      applianceUsageDueDate
    } = this.props;
    return (
      <Loading show={loading}>
        <Error message={error}>
          <div>
            {isAppliance ? (
              <ApplianceStatusNotification
                applianceUsageRecords={applianceUsageRecords}
                applianceUsageDueDate={applianceUsageDueDate}
                isModalShown={this.state.showApplianceStatusModal}
                showModal={this.showApplianceStatusModal}
                hideModal={this.hideApplianceStatusModal}
                showOutdatedAlert
                showInfoLink
              />
            ) : (
              <Auth0Notification type="primary">
                {REPORT_REFRESH_24HRS}
              </Auth0Notification>
            )}
            <QuotaSummaryUsersConsumption
              shouldRenderSummary={shouldRenderSummary}
              quotaReportData={
                reportData &&
                reportData.quotaReportData &&
                reportData.quotaReportData.overview
              }
              showReportDetails={showReportDetails}
              contactSales={contactSales}
              contactSalesLink={contactSalesLink}
              isAppliance={isAppliance}
              isMixedPlan={
                reportData &&
                reportData.quotaReportData &&
                reportData.quotaReportData.reportType === 'mixedCustomAgreement'
              }
            />
            <QuotaSummaryFeatureConsumption
              shouldRenderSummary={shouldRenderSummary}
              enterpriseConnectionsReportData={
                reportData &&
                reportData.enterpriseConnectionsReportData &&
                reportData.enterpriseConnectionsReportData.overview
              }
              featuresReportData={
                reportData &&
                reportData.featuresReportData &&
                reportData.featuresReportData.overview
              }
              showReportDetails={showReportDetails}
              contactSales={contactSales}
              contactSalesLink={contactSalesLink}
              isAppliance={isAppliance}
            />
          </div>
        </Error>
      </Loading>
    );
  }
}

QuotaSummary.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.string,
  reportData: PropTypes.object,
  contactSales: PropTypes.func,
  contactSalesLink: PropTypes.string,
  showReportDetails: PropTypes.func,
  shouldRenderSummary: PropTypes.bool,
  isAppliance: PropTypes.bool,
  applianceUsageRecords: PropTypes.array,
  applianceUsageDueDate: PropTypes.string
};

QuotaSummary.defaultProps = {
  showReportDetails: noop
};

export default QuotaSummary;
